var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-dark text-lg px-2 py-3 text-left",staticStyle:{"text-transform":"inherit"}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }